import React from "react";

import { WORKSPACE_VIEW, CONTEXT_WORKSPACE } from "../../changesConstants";

import { ChangeTypeSelector } from "./child/ChangeTypeSelector";
import { ViewTypeSelector } from "./child/ViewTypeSelector";
import { Loader } from "./child/Loader";
import { ChangeToColorMappingType } from "../../types";

interface ChangesBodyProps {
    context?: string;
    viewType: string;
    displayLoading?: boolean;
    isCesium?: boolean;
    changeTypeColoring?: ChangeToColorMappingType;
    selectedChangeTypes?: string[];
    handleViewTypeChanged: (viewType: string) => void;
    handleChangesTypeChanged: (changeType: string, value: boolean) => void;
}

export const ChangesBody = (props: ChangesBodyProps) => {
    const {
        context,
        viewType,
        handleChangesTypeChanged,
        changeTypeColoring,
        selectedChangeTypes,
        handleViewTypeChanged,
        displayLoading,
        isCesium,
    } = props;
    return (
        <div className={"changesVisualizationPanelBody"}>
            <ViewTypeSelector
                hidden={context !== CONTEXT_WORKSPACE}
                handleViewTypeChanged={handleViewTypeChanged}
                viewType={viewType}
                displayLoading={displayLoading!}
            />

            <ChangeTypeSelector
                selectedChangeTypes={selectedChangeTypes!}
                disabled={displayLoading!}
                handleChangesTypeChanged={handleChangesTypeChanged}
                changeTypeColoring={changeTypeColoring!}
                hidden={viewType !== WORKSPACE_VIEW || isCesium!}
            />

            <Loader displayLoading={displayLoading!} />
        </div>
    );
};
